module.exports = __webpack_public_path__ + "img/niupai_b.1dd214ae.png";